// src/pages/store/Dashboard.js
import React from "react";      
import StoreDashboardComp from "../../components/Store/StoreDashboard";

export default function StoreDashboard() {
  return (
    <>
      <StoreDashboardComp />
    </>
  );
}
